<template>
</template>

<script>
  export default {
    mounted() {
      console.log(12312312)
      this.getLocation()
    },
    methods:{
      getLocation() {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            // this.location = `纬度: ${position.coords.latitude}, 经度: ${position.coords.longitude}`;
            const lat = String(
              Number(parseFloat(`${position.coords.latitude}`).toFixed(20))
            );
            const lon = String(
              Number(parseFloat(`${position.coords.longitude}`).toFixed(20))
            );
            console.log(position)
            alert(lat+"*"+lon)
            //this.getLocationDetails(lon, lat);
          },
          (error) => {
            console.error(error.message);
            alert(error.message)
          },
          {
              enableHighAccuracy: true, // 启用高精度定位
              timeout: 5000, // 5 秒超时
              maximumAge: 0 //  不使用缓存
          }
        );
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/cscscs.vue